export const withCurrency = (num: number = 0) =>  {
  const reg = /(\B)(?=(\d{3})+$)/g;
  return num.toString().replace(reg, ',');
}